import React from 'react';
import Address from './address';
import { AccentBackground } from 'scy/Background';
import { H1, Subtitle } from 'scy/text';
import styles from './hero.mod.scss';

export default function LandingPageHero({ title, subtitle, onAddressSuccess }) {
  return (
    <AccentBackground tag="section" className={styles.section}>
      <div
        className={styles.backgroundImage}
        role="img"
        aria-label="man lounging on lawn chair holding pineapple beverage"
      />
      <H1 className={styles.heading}>
        {title ? title : 'Alcohol delivery in minutes.'}
      </H1>
      <Subtitle className={styles.subtitle}>
        {subtitle ||
          'Alcohol delivery in 30 mins means you can let the good times roll.'}
      </Subtitle>
      <Address
        autoFocus
        scrollOnSubmit
        onSuccess={onAddressSuccess}
        trackingParams={{ page: 'Homepage', source: 'Homepage Hero' }}
        className={styles.address}
      />
    </AccentBackground>
  );
}
